/**
 * Meanbook Note - Role & Authentication Utilities Module
 */

export function getAssignedRoles(currentUserStaffData) {
  if (currentUserStaffData && Array.isArray(currentUserStaffData.roles)) {
    return currentUserStaffData.roles;
  }
  const storedRoles = localStorage.getItem("userRoles");
  if (storedRoles) {
    try {
      return JSON.parse(storedRoles);
    } catch (e) {
      return [];
    }
  }
  return [];
}

export function getUserRoles(currentUserStaffData) {
  const assignedRoles = getAssignedRoles(currentUserStaffData);
  if (assignedRoles.length <= 1) {
    return assignedRoles;
  }
  const activeRole = localStorage.getItem("activeRole");
  if (activeRole && assignedRoles.includes(activeRole)) {
    return [activeRole];
  }
  return [assignedRoles[0]];
}

export function hasRole(requiredRoles, currentUserStaffData) {
  const roles = getUserRoles(currentUserStaffData);
  if (roles.includes("Super Admin")) return true;
  if (Array.isArray(requiredRoles)) {
    return requiredRoles.some(r => roles.includes(r));
  }
  return roles.includes(requiredRoles);
}

export function canUndoOrder(order, roles) {
  if (!order || !roles) return false;
  if (roles.includes("Super Admin")) return true;

  return roles.some(role => {
    if (role === "Order Manager") {
      return (order.readyToShip === true && !order.isPacked) ||
        (order.readyToShip === true && order.isPacked === true && !order.trackingNumber && order.deliveryType === 'express') ||
        (order.readyToShip === true && order.isPacked === true && order.deliveryType !== 'express') ||
        (order.maxShipments > 1 && order.currentShipment > 1 && !order.readyToShip && order.deliveryType !== 'express');
    } else if (role === "Packer & Picker") {
      return (order.readyToShip === true && order.isPacked === true && !order.trackingNumber && order.deliveryType === 'express') ||
        (order.readyToShip === true && order.isPacked === true && order.deliveryType !== 'express') ||
        (order.maxShipments > 1 && order.currentShipment > 1 && !order.readyToShip && order.deliveryType !== 'express');
    } else if (role === "Shipper") {
      return (order.deliveryType === 'express' && !!order.trackingNumber) ||
        (order.maxShipments > 1 && order.currentShipment > 1 && !order.readyToShip && order.deliveryType === 'express');
    }
    return false;
  });
}
